import { render, staticRenderFns } from "./GvItem.vue?vue&type=template&id=1f3fc938&"
import script from "./GvItem.vue?vue&type=script&lang=js&"
export * from "./GvItem.vue?vue&type=script&lang=js&"
import style0 from "./GvItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports